import axios from 'axios';
import { apiErrorHandler } from '../services/api';
import { v2ApiErrorHandler } from '@/api/lib/error-handler';
import * as Api from './index';

// find points of contact
export const findPointsOfContact = () => {
    const url = Api.getv2ApiBase('/user/points-of-contact');

    return axios
        .get(url, Api.getOptions())
        .then((response) => {
            return response.data;
        })
        .catch(
            apiErrorHandler({
                apiName: 'Find School By Id error'
            })
        );
};

export const listUsersByEmail = ({ params }) => {
    const url = Api.getv2ApiBase(`/user/list-by-email`);
    const options = Api.getOptions();

    return axios
        .get(url, { ...options, params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => v2ApiErrorHandler({ error }));
};

export const getStudentDetailsById = ({ studentId, errorHandlerOptions = {} }) => {
    const url = Api.getv2ApiBase(`/user/student/${studentId}`);
    return axios
        .get(url, Api.getOptions())
        .then((response) => {
            return response.data;
        })
        .catch((error) =>
            v2ApiErrorHandler({
                error,
                ...errorHandlerOptions
            })
        );
};

// Retires a single user or users in bulk
export const retireUsers = ({
    userEmails,
    schoolId,
    includeAdmins = false,
    errorHandlerOptions = {}
}) => {
    const url = Api.getv2ApiBase(`/user/retire`);
    const payload = { userEmails, schoolId, includeAdmins };

    return axios
        .patch(url, payload, Api.getOptions())
        .then((response) => {
            return response.data;
        })
        .catch((error) =>
            v2ApiErrorHandler({
                error,
                ...errorHandlerOptions
            })
        );
};

// refreshes a staff or admin user details by id
// this is ported over from django where it was used to refresh the user details
export const refreshStaffOrAdminById = async () => {
    try {
        const url = Api.getv2ApiBase(`/user/refresh-staff-or-admin`);
        const defaultOptions = Api.getOptions();

        const response = await axios.get(url, { ...defaultOptions });
        return response.data;
    } catch (error) {
        v2ApiErrorHandler({
            error
        });
    }
};

// Updates the school of a staff user
export const updateStaffSchoolById = async ({ schoolId, errorHandlerOptions = {} }) => {
    try {
        const url = Api.getv2ApiBase(`/user/staff/update-school`);
        const defaultOptions = Api.getOptions();

        const response = await axios.patch(url, { schoolId }, { ...defaultOptions });
        return response.data;
    } catch (error) {
        console.error('Error updating staff school:', error);
        v2ApiErrorHandler({
            error,
            ...errorHandlerOptions
        });
    }
};

// Lists students with various filters and options
export const listStudents = async ({
    page = 1,
    page_size = 25,
    academicRiskLevel,
    engagementRiskLevel,
    financialRiskLevel,
    wellnessRiskLevel,
    overallRiskLevel,
    schoolId,
    search,
    tagIds,
    ordering,
    riskSubDriver,
    invalidPhoneNumber,
    optedOutOfSms,
    errorHandlerOptions = {}
}) => {
    const url = Api.getv2ApiBase('/user/students');
    const options = {
        ...Api.getOptions()
    };
    const params = {
        page,
        page_size,
        academicRiskLevel,
        engagementRiskLevel,
        financialRiskLevel,
        wellnessRiskLevel,
        overallRiskLevel,
        schoolId,
        search,
        tagIds,
        ordering,
        riskSubDriver,
        invalidPhoneNumber,
        optedOutOfSms
    };

    try {
        const response = await axios.get(url, { ...options, params });
        return response.data;
    } catch (error) {
        v2ApiErrorHandler({
            error,
            ...errorHandlerOptions
        });
    }
};
